import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Briefcase, ArrowRight } from "lucide-react";

export default function ManagerProjects() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/projects/").then(r => setItems(r.data || [])).catch(() => {}); }, []);
  return (
    <div>
      <h1 className="font-display text-2xl font-bold text-slate-900 mb-1">I tuoi progetti</h1>
      <p className="text-sm text-slate-600 mb-6">Workspace condiviso con le aziende che hai supportato.</p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {items.map(p => (
          <Link key={p.id} to={`/manager/projects/${p.id}`}>
            <div className="cxo-card p-6 h-full">
              <Badge className={`border-0 ${p.status === "active" ? "bg-[#E9F8F1] text-[#1F9D6A]" : "bg-slate-100 text-slate-700"}`}>{p.status}</Badge>
              <h3 className="mt-3 font-semibold text-slate-900">{p.title}</h3>
              <p className="text-xs text-slate-500">Azienda: {p.company?.company_name}</p>
              <p className="text-xs text-slate-500">Pacchetto: {p.package}</p>
              <div className="mt-4 inline-flex items-center text-sm font-semibold text-[#2D6BFF]">Apri workspace <ArrowRight size={14} className="ml-1" /></div>
            </div>
          </Link>
        ))}
        {!items.length && <div className="cxo-card p-10 text-center text-slate-500 col-span-2">Nessun progetto attivo</div>}
      </div>
    </div>
  );
}
